<template>
  <WithSpinnerLoading
    :loading="loading"
    class="bid-pause-status-column-content"
  >
    <ElPopover v-model="visible" placement="top" width="150" trigger="click">
      <ListSelect :value="active" :items="statusItems" @input="changeStatus" />
      <div
        slot="reference"
        class="bid-pause-status-column-content__content pointer"
      >
        <i
          class="bid-pause-status-column-content__badge"
          :class="{
            'bid-pause-status-column-content__badge--active': active,
          }"
        />
        <i
          class="el-icon-caret-bottom bid-pause-status-column-content__caret"
          :class="{
            'bid-pause-status-column-content__caret--active': isHovered,
          }"
        />
      </div>
    </ElPopover>
  </WithSpinnerLoading>
</template>

<script>
import ListSelect from '@@/advertisement/common/ListSelect';

import { CHANGE_SINGLE_BID_STATUS } from '@/store/types';
import { mapActions } from 'vuex';

import campaignId from '@/mixins/advertisement/campaignId';

import WithSpinnerLoading from '@@/advertisement/common/WithSpinnerLoading';

export default {
  name: 'BidPauseStatusColumnContent',
  components: {
    ListSelect,
    WithSpinnerLoading,
  },
  mixins: [campaignId],
  props: {
    initialPaused: {
      required: true,
      type: Boolean,
    },
    isHovered: {
      required: true,
      type: Boolean,
    },
    id: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      visible: false,
      active: !this.initialPaused,
      loading: false,
    };
  },
  computed: {
    statusItems() {
      return [
        {
          value: true,
          label: this.$t('ACTIVE'),
          icon: 'play_arrow',
        },
        {
          value: false,
          label: this.$t('ADVERTISEMENT.BIDS.PAUSE'),
          icon: 'pause',
        },
      ];
    },
  },
  watch: {
    initialPaused(newVal, val) {
      if (newVal !== val) {
        this.active = !newVal;
      }
    },
  },
  methods: {
    ...mapActions({
      editBidStatus: CHANGE_SINGLE_BID_STATUS,
    }),
    hidePopover() {
      this.visible = false;
    },
    changeStatus(newActiveStatus) {
      this.hidePopover();

      this.loading = true;

      return this.editBidStatus({
        campaignId: this.campaignId,
        id: this.id,
        paused: !newActiveStatus,
      })
        .then(message => {
          this.$message.success(message);

          this.active = newActiveStatus;
        })
        .catch(({ message }) => {
          this.$message.error(message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss">
.bid-pause-status-column-content {
  display: flex;
  justify-content: center;
  align-items: center;

  &__content {
    display: flex;
    align-items: center;
  }

  &__badge {
    width: rem-calc(10px);
    height: rem-calc(10px);
    display: inline-block;
    border-radius: 50%;
    background-color: $lb-color-warning;

    &--active {
      background-color: $lb-color-success;
    }
  }

  &__caret {
    opacity: 0;

    &--active {
      opacity: 1;
    }
  }
}
</style>
